import { useEffect, useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';
import { useConfirm } from 'material-ui-confirm';

import DialogHeader from 'components/DialogHeader';
import * as socketEvents from 'constants/socketEvents';
import useAuth from 'hooks/useAuth';
import socket from 'services/socket';
import redirectToAuth from 'utils/redirectToAuth';

export default function ModalUsuarioDesautenticado() {
  const confirm = useConfirm();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const auth = useAuth();

  // após ser desautenticado encerra a sessão no core (os cookies são httpOnly) e o envia
  // para se autenticar novamente; sem o logout, o auth o devolveria logado para cá
  const handleButtonClick = async () => {
    await auth.signOut();

    redirectToAuth();
  };

  // Observa se o cliente do socket foi desautenticado
  useEffect(() => {
    const handler = ({ message }: { message: string }) => {
      setOpen(true);
      setMessage(message);
    };

    socket.on(socketEvents.ON_DESAUTENTICADO, handler);

    return () => {
      socket.off(socketEvents.ON_DESAUTENTICADO, handler);
    };
  }, [confirm]);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogHeader title="Ops!" />
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleButtonClick}>Ok, entendi!</Button>
      </DialogActions>
    </Dialog>
  );
}
